module.exports = __webpack_public_path__ + "static/media/share_linkedin.3a0b2505.svg";